import { RouteInfo } from './vertical-menu.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'navigation.dashboard',
    icon: 'ft-home',
    class: 'dropdown nav-item',
    isExternalLink: false,
    submenu: [],
    roles: ['A', 'C'],
  },
  {
    path: '/income',
    title: 'navigation.income',
    icon: 'ft-dollar-sign',
    class: 'dropdown nav-item has-sub',
    isExternalLink: false,
    submenu: [
      {
        path: '/income-sent',
        title: 'navigation.incomeSent',
        icon: 'ft-dollar-sign',
        class: 'dropdown nav-item',
        isExternalLink: false,
        submenu: [],
        roles: ['A', 'C'],
      },
      // {
      //   path: '/income-processed',
      //   title: 'navigation.incomeProcessed',
      //   icon: 'ft-dollar-sign',
      //   class: 'dropdown nav-item',
      //   isExternalLink: false,
      //   submenu: [],
      //   roles: ['A', 'C'],
      // },
    ],
    roles: ['A', 'C'],
  },
  {
    path: '/movies-data',
    title: 'navigation.moviesData',
    icon: 'ft-film',
    class: 'dropdown nav-item',
    isExternalLink: false,
    submenu: [],
    roles: ['A', 'C'],
  },
  // {
  //   path: '/endpoints-list',
  //   title: 'navigation.endpointsList',
  //   icon: 'ft-share-2',
  //   class: 'dropdown nav-item',
  //   isExternalLink: false,
  //   submenu: [],
  //   roles: ['A', 'C'],
  // },
  {
    path: '/cinema-data',
    title: 'navigation.cinemaData',
    icon: 'ft-grid',
    class: 'dropdown nav-item',
    isExternalLink: false,
    submenu: [],
    roles: ['A', 'C'],
  },
  {
    path: '/users-data',
    title: 'navigation.usersData',
    icon: 'ft-user',
    class: 'dropdown nav-item',
    isExternalLink: false,
    submenu: [],
    roles: ['A'],
  },
];
